import type { TMessages } from '@/types/TMessages'

export const messages = {
  cartError: {
    deleteCartItemError: {
      title: 'Ошибка удаления',
      text: 'Не удалось удалить выбранный товар. Попробуйте повторить позднее.',
      button: 'Закрыть',
    },
    addCartItemError: {
      title: 'Ошибка добавления',
      text: 'Не удалось добавить выбранный товар. Попробуйте повторить позднее.',
      button: 'Закрыть',
    },
    deletingOrderError: {
      title: 'Ошибка удаления',
      text: 'Не удалось удалить выбранный заказ. Попробуйте повторить позднее.',
      button: 'Закрыть',
    },
    makingOrderError: {
      title: 'Ошибка оформления',
      text: 'Не удалось оформить заказ. Попробуйте повторить позднее.',
      button: 'Закрыть',
    },
  },
} satisfies TMessages
